/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/no-array-index-key */
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import { IconButton, Button } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CloseIcon from '@mui/icons-material/Close';
import { saveAs } from 'file-saver';
import {
  AlignmentType,
  BorderStyle,
  Document,
  Packer,
  Paragraph,
  ShadingType,
  Table,
  TableCell,
  TableRow,
  TextRun,
  VerticalAlign,
  VerticalMergeType,
  WidthType,
} from 'docx';

moment.locale('ko');

const REPORT_CSS = `
  .rp-a4 {
    width: 210mm; min-height: 297mm; padding: 15mm; background: white;
    box-sizing: border-box; position: relative; display: block;
  }
  .rp-table { border-collapse: collapse; width: 100%; table-layout: fixed; }
  .rp-flex { display: flex; }
  .rp-flex-col { flex-direction: column; }
  .rp-center { text-align: center; }
  .rp-left { text-align: left; }
  .rp-right { text-align: right; }
  .rp-bold { font-weight: 700; }
  .rp-border { border: 1px solid black; }
  .rp-border2 { border: 2px solid black; }
  .rp-border-r { border-right: 1px solid black; }
  .rp-border-b { border-bottom: 1px solid black; }
  .rp-border-b2 { border-bottom: 2px solid black; }
  .rp-bg-gray { background-color: #f3f4f6; }
  .rp-bg-white { background-color: white; }
  .rp-p1 { padding: 4px; }
  .rp-p2 { padding: 8px; }
  .rp-px2 { padding-left: 8px; padding-right: 8px; }
  .rp-py3 { padding-top: 12px; padding-bottom: 12px; }
  .rp-mb1 { margin-bottom: rpx; }
  .rp-mb2 { margin-bottom: 8px; }
  .rp-mb4 { margin-bottom: 16px; }
  .rp-my2 { margin-top: 8px; margin-bottom: 8px; }
  .rp-h8 { height: 32px; }
  .rp-h10 { height: 40px; }
  .rp-h16 { height: 64px; }
  .rp-w-full { width: 100%; }
  .rp-text-xs { font-size: 12px; }
  .rp-text-10 { font-size: 10px; }
  .rp-text-9 { font-size: 9px; }
  .rp-text-lg { font-size: 18px; }
  .rp-text-xl { font-size: 20px; }
  .rp-text-2xl { font-size: 24px; }
  .rp-rounded { border-radius: 16px; }
  .rp-leading { line-height: 1.25; }
  .rp-input {
    width: 100%; border: none; outline: none; background: transparent;
    font-size: inherit; font-family: inherit; padding: 8px; color: inherit;
  }
  .rp-input:focus { background: rgba(37,99,235,0.06); border-radius: 2px; }
  .rp-input:disabled { background: transparent; color: inherit; cursor: default; opacity: 1; }
  .rp-textarea {
    width: 100%; border: none; outline: none; background: transparent;
    font-size: inherit; font-family: inherit; padding: 8px; resize: none;
    min-height: 48px; color: inherit;
  }
  .rp-textarea:focus { background: rgba(37,99,235,0.06); border-radius: 2px; }
  .rp-check-cell { cursor: pointer; user-select: none; transition: background 0.15s; }
  .rp-check-cell:hover { background: rgba(37,99,235,0.08); }
  .rp-radio-cell { cursor: pointer; user-select: none; transition: background 0.12s; }
  .rp-radio-cell:hover { background: rgba(37,99,235,0.08); }
  .rp-cell-disabled { opacity: 0.3; cursor: default; pointer-events: none; }
  .rp-note-input {
    width: 100%; border: none; outline: none; background: transparent;
    font-size: 11px; font-family: inherit; resize: none; padding: 8px;
    color: inherit;
  }
  .rp-note-input:focus { background: rgba(37,99,235,0.06); border-radius: 2px; }
  .rp-note-input:disabled { opacity: 0.3; cursor: not-allowed; }
`;

const PRINT_STYLES = `
  * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; box-sizing: border-box; }
  @page { size: A4; margin: 15mm; }
  body { margin: 0; padding: 0; background: white; }
  .rp-a4 {
    width: 100%; padding: 0; margin: 0;
    background: white; display: block;
    page-break-after: always;
  }
  .rp-a4:last-child { page-break-after: auto; }
  .rp-table { border-collapse: collapse; width: 100%; table-layout: fixed; }
  td { padding: 8px; }
  tr { page-break-inside: avoid; break-inside: avoid; }
  thead { display: table-header-group; }
  h1 { margin: 0; padding: 0; }
  .rp-flex { display: flex; }
  .rp-flex-col { flex-direction: column; }
  .rp-center { text-align: center; }
  .rp-left { text-align: left; }
  .rp-right { text-align: right; }
  .rp-bold { font-weight: 700; }
  .rp-border { border: 1px solid black; }
  .rp-border2 { border: 2px solid black; }
  .rp-border-r { border-right: 1px solid black; }
  .rp-border-b { border-bottom: 1px solid black; }
  .rp-border-b2 { border-bottom: 2px solid black; }
  .rp-bg-gray { background-color: #f3f4f6 !important; }
  .rp-bg-white { background-color: white !important; }
  .rp-p1 { padding: 4px; }
  .rp-p2 { padding: 8px; }
  .rp-px2 { padding-left: 8px; padding-right: 8px; }
  .rp-py3 { padding-top: 12px; padding-bottom: 12px; }
  .rp-mb2 { margin-bottom: 8px; }
  .rp-mb4 { margin-bottom: 16px; }
  .rp-my2 { margin-top: 8px; margin-bottom: 8px; }
  .rp-h8 { height: 32px; }
  .rp-h10 { height: 40px; }
  .rp-h16 { height: 64px; }
  .rp-w-full { width: 100%; }
  .rp-text-xs { font-size: 12px; }
  .rp-text-10 { font-size: 10px; }
  .rp-text-9 { font-size: 9px; }
  .rp-text-xl { font-size: 20px; }
  .rp-text-2xl { font-size: 24px; }
  .rp-rounded { border-radius: 16px; }
  .rp-leading { line-height: 1.25; }
`;

const PAGE_SHADOW =
  '0 2px 4px rgba(0,0,0,0.3), 0 8px 20px rgba(0,0,0,0.35), 0 20px 48px rgba(0,0,0,0.2)';

const SCORE_KEYS = ['participation', 'satisfaction', 'performance'];
const SCORE_LABELS = ['상', '중', '하'];

const normalizeRecipients = (recipients) =>
  (recipients || []).map((r) => ({
    name: r.name || '',
    attended: r.attended ?? false,
    scores: r.scores ?? {
      participation: null,
      satisfaction: null,
      performance: null,
    },
    note: r.note ?? '',
  }));

// A4 content width (mm → DXA: 1mm ≈ 56.7 DXA). A4=11906, margins 15mm*2=1702 → content=10204
const CW = 10204;
const dxa = (n) => ({ size: n, type: WidthType.DXA });

const BORDER_THIN = { style: BorderStyle.SINGLE, size: 8, color: '000000' };
const BORDER_THICK = { style: BorderStyle.SINGLE, size: 16, color: '000000' };
const CELL_BORDERS = {
  top: BORDER_THIN,
  bottom: BORDER_THIN,
  left: BORDER_THIN,
  right: BORDER_THIN,
};
const OUTER_BORDERS = {
  top: BORDER_THICK,
  bottom: BORDER_THICK,
  left: BORDER_THICK,
  right: BORDER_THICK,
};
const GRAY_SHADING = { type: ShadingType.CLEAR, fill: 'f3f4f6', color: 'auto' };
const CELL_PAD = { top: 80, bottom: 80, left: 120, right: 120 };
const PT = (pt) => pt * 2;
const KR = (text, opts = {}) =>
  new TextRun({ text: text || '', font: 'Malgun Gothic', ...opts });

const docxHCell = (text, opts = {}) =>
  new TableCell({
    children: [
      new Paragraph({
        children: [KR(text, { bold: true, size: PT(9) })],
        alignment: AlignmentType.CENTER,
      }),
    ],
    shading: GRAY_SHADING,
    borders: CELL_BORDERS,
    margins: CELL_PAD,
    verticalAlign: VerticalAlign.CENTER,
    ...opts,
  });

const docxVCell = (text, opts = {}) => {
  const lines = String(text || '').split('\n');
  return new TableCell({
    children: lines.map(
      (line) => new Paragraph({ children: [KR(line, { size: PT(9) })] }),
    ),
    borders: CELL_BORDERS,
    margins: CELL_PAD,
    verticalAlign: VerticalAlign.CENTER,
    ...opts,
  });
};

const docxContCell = (opts = {}) =>
  new TableCell({
    children: [new Paragraph({ children: [] })],
    shading: GRAY_SHADING,
    borders: CELL_BORDERS,
    margins: CELL_PAD,
    verticalMerge: VerticalMergeType.CONTINUE,
    ...opts,
  });

const tableBorder = (rows, opts = {}) =>
  new Table({
    width: dxa(CW),
    borders: { ...OUTER_BORDERS, insideH: BORDER_THIN, insideV: BORDER_THIN },
    rows,
    ...opts,
  });

const generateDocx = async (fd) => {
  const p = fd.programInfo || {};
  const recipients = fd.recipients || [];
  const attendedCount = recipients.filter((r) => r.attended).length;
  const total = recipients.length;
  const rate =
    total > 0
      ? `${attendedCount}/${total}(${Math.round((attendedCount / total) * 100)}%)`
      : '';
  const instructorsText = Array.isArray(p.instructors)
    ? p.instructors.join(', ')
    : p.instructors || '';

  // Info table column widths in DXA (16+34+18+32 = 100%)
  const IC = [
    Math.round(CW * 0.16),
    Math.round(CW * 0.34),
    Math.round(CW * 0.18),
    CW - Math.round(CW * 0.16) - Math.round(CW * 0.34) - Math.round(CW * 0.18),
  ];

  const infoTable = tableBorder([
    new TableRow({
      children: [
        docxHCell('프로그램 활동명', { width: dxa(IC[0]) }),
        docxVCell(p.name, { width: dxa(IC[1]) }),
        docxHCell('프로그램 그룹', { width: dxa(IC[2]) }),
        docxVCell(p.group, { width: dxa(IC[3]) }),
      ],
    }),
    new TableRow({
      children: [
        docxHCell('프로그램 유형 구분'),
        docxVCell(p.type, { columnSpan: 3 }),
      ],
    }),
    new TableRow({
      children: [docxHCell('운영일시'), docxVCell(p.date, { columnSpan: 3 })],
    }),
    new TableRow({
      children: [
        docxHCell('작성자'),
        docxVCell(p.author),
        docxHCell('시설장'),
        docxVCell(p.director),
      ],
    }),
    new TableRow({
      children: [
        docxHCell('장소'),
        docxVCell(p.location),
        docxHCell('참여자/현원(참여율)'),
        docxVCell(rate),
      ],
    }),
    new TableRow({
      children: [
        docxHCell('진행자명'),
        docxVCell(instructorsText, { columnSpan: 3 }),
      ],
    }),
    new TableRow({
      children: [
        docxHCell('준비물'),
        docxVCell(p.materials, { columnSpan: 3 }),
      ],
    }),
    new TableRow({
      children: [docxHCell('목표'), docxVCell(p.goal, { columnSpan: 3 })],
    }),
    new TableRow({
      children: [
        docxHCell('프로그램 내용\n(진행과정)'),
        docxVCell(p.content, { columnSpan: 3 }),
      ],
    }),
    new TableRow({
      children: [
        docxHCell('전반적 평가'),
        docxVCell(p.overallEvaluation, { columnSpan: 3 }),
      ],
    }),
  ]);

  const trainingLabels = fd.recoveryTraining || [];
  const checks = fd.recoveryChecks || Array(8).fill(false);
  const TC = Math.round(CW / 8); // training col width

  const trainingTable = tableBorder([
    new TableRow({
      children: [
        docxHCell(
          '급여제공 기록지 > 기능회복훈련 > 신체·인지기능 향상 프로그램에 표시',
          { columnSpan: 7 },
        ),
        docxVCell('V', { columnSpan: 1 }),
      ],
    }),
    new TableRow({
      children: trainingLabels.map((arr, idx) =>
        docxHCell(Array.isArray(arr) ? arr.join(' ') : arr, { width: dxa(TC) }),
      ),
    }),
    new TableRow({
      children: Array.from({ length: 8 }).map(
        (_, idx) =>
          new TableCell({
            children: [
              new Paragraph({
                children: [
                  KR(checks[idx] ? 'V' : '', { bold: true, size: PT(9) }),
                ],
                alignment: AlignmentType.CENTER,
              }),
            ],
            borders: CELL_BORDERS,
            margins: CELL_PAD,
            verticalAlign: VerticalAlign.CENTER,
            width: dxa(TC),
          }),
      ),
    }),
  ]);

  // Recipients table col widths in DXA
  // no=7%, name=10%, attended=7%, score=5%×9, note=나머지(≈31%)
  const RC = {
    no: Math.round(CW * 0.07),
    name: Math.round(CW * 0.10),
    attended: Math.round(CW * 0.07),
    score: Math.round(CW * 0.05),
    note:
      CW -
      Math.round(CW * 0.07) -
      Math.round(CW * 0.10) -
      Math.round(CW * 0.07) -
      Math.round(CW * 0.05) * 9,
  };

  const rDataCell = (text, center = false, bold = false) =>
    new TableCell({
      children: [
        new Paragraph({
          children: [KR(text, { bold, size: PT(8) })],
          alignment: center ? AlignmentType.CENTER : AlignmentType.LEFT,
        }),
      ],
      borders: CELL_BORDERS,
      margins: CELL_PAD,
      verticalAlign: VerticalAlign.CENTER,
    });

  const recipientsTable = tableBorder([
    new TableRow({
      children: [
        docxHCell('연번', {
          width: dxa(RC.no),
          verticalMerge: VerticalMergeType.RESTART,
        }),
        docxHCell('수급자명', {
          width: dxa(RC.name),
          verticalMerge: VerticalMergeType.RESTART,
        }),
        docxHCell('참여', {
          width: dxa(RC.attended),
          verticalMerge: VerticalMergeType.RESTART,
        }),
        docxHCell('참여도', { columnSpan: 3, width: dxa(RC.score * 3) }),
        docxHCell('만족도', { columnSpan: 3, width: dxa(RC.score * 3) }),
        docxHCell('수행도', { columnSpan: 3, width: dxa(RC.score * 3) }),
        docxHCell('반응 및 특이사항(미참여 사유)', {
          width: dxa(RC.note),
          verticalMerge: VerticalMergeType.RESTART,
        }),
      ],
    }),
    new TableRow({
      children: [
        docxContCell({ width: dxa(RC.no) }),
        docxContCell({ width: dxa(RC.name) }),
        docxContCell({ width: dxa(RC.attended) }),
        ...Array.from({ length: 9 }).map((_, i) =>
          docxHCell(SCORE_LABELS[i % 3], { width: dxa(RC.score) }),
        ),
        docxContCell({ width: dxa(RC.note) }),
      ],
    }),
    ...recipients.map(
      (r, i) =>
        new TableRow({
          children: [
            rDataCell(String(i + 1), true),
            rDataCell(r.name || '', true, true),
            rDataCell(r.attended ? 'V' : '', true, true),
            ...Array.from({ length: 9 }).map((_, j) => {
              const scoreKey = SCORE_KEYS[Math.floor(j / 3)];
              const label = SCORE_LABELS[j % 3];
              return rDataCell(
                r.scores?.[scoreKey] === label ? 'V' : '',
                true,
                true,
              );
            }),
            rDataCell(r.note || ''),
          ],
        }),
    ),
  ]);

  const pageProps = {
    size: { width: 11906, height: 16838 },
    margin: { top: 851, bottom: 851, left: 851, right: 851 },
  };

  const mkPara = (text, opts = {}) =>
    new Paragraph({
      children: [KR(text, opts.run)],
      alignment: opts.align,
      spacing: { before: opts.spaceBefore ?? 0, after: opts.spaceAfter ?? 60 },
    });

  const doc = new Document({
    styles: {
      default: {
        document: { run: { font: 'Malgun Gothic', size: PT(9) } },
      },
    },
    sections: [
      {
        properties: { page: pageProps },
        children: [
          mkPara(fd.header?.outline || '', {
            run: { size: PT(7) },
            spaceAfter: 40,
          }),
          mkPara(fd.header?.title || '', {
            run: { bold: true, size: PT(16) },
            align: AlignmentType.CENTER,
            spaceAfter: 40,
          }),
          ...(fd.header?.category
            ? [
                mkPara(fd.header.category, {
                  run: { size: PT(10) },
                  align: AlignmentType.CENTER,
                  spaceAfter: 60,
                }),
              ]
            : []),
          mkPara(fd.header?.centerName || '', {
            run: { bold: true, size: PT(11) },
            align: AlignmentType.RIGHT,
            spaceAfter: 120,
          }),
          infoTable,
          mkPara('', { spaceBefore: 120, spaceAfter: 40 }),
          mkPara('기능회복훈련', {
            run: { bold: true, size: PT(11) },
            align: AlignmentType.CENTER,
            spaceAfter: 80,
          }),
          trainingTable,
        ],
      },
      {
        properties: { page: pageProps },
        children: [
          mkPara('수급자 리스트', {
            run: { bold: true, size: PT(16) },
            align: AlignmentType.CENTER,
            spaceAfter: 120,
          }),
          recipientsTable,
        ],
      },
    ],
  });

  const blob = await Packer.toBlob(doc);
  saveAs(blob, `프로그램운영기록지_${fd.header?.centerName || ''}.docx`);
};

const Field = ({ value, onChange, multiline, placeholder, maxLength }) => {
  if (multiline) {
    return (
      <textarea
        className="rp-textarea"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        rows={2}
      />
    );
  }
  return (
    <input
      className="rp-input"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      maxLength={maxLength}
    />
  );
};

const DateTimeField = ({ onChange }) => {
  const [startDt, setStartDt] = useState('');
  const [endDt, setEndTime] = useState('');

  const format = (dt, et) => {
    if (!dt) return '';
    const m = moment(dt);
    const e = moment(et);
    const sameDay = et && m.isSame(e, 'day');
    const etFormatted = et ? e.format('HH:mm') : '';
    const startTime = m.format('HH:mm');
    const times = sameDay ? `${startTime}~${etFormatted}` : startTime;
    return sameDay
      ? `${m.format('YYYY.MM.DD. (dddd)')} ${times}`
      : `${m.format('YYYY.MM.DD. (dddd) HH:mm')} ~ ${e.format('YYYY.MM.DD. (dddd) HH:mm')}`;
  };

  const handleStartChange = (v) => {
    setStartDt(v);
    if (!endDt) setEndTime(moment(v).add(1, 'hour').format('YYYY-MM-DDTHH:mm'));
    onChange(format(v, endDt));
  };
  const handleEndChange = (v) => {
    setEndTime(v);
    onChange(format(startDt, v));
  };

  const formatted = format(startDt, endDt);
  const inputStyle = {
    fontSize: '12px',
    fontFamily: 'inherit',
    border: '1px solid #d1d5db',
    borderRadius: 3,
    padding: '2px 4px',
    outline: 'none',
    background: 'transparent',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 8px',
        flexWrap: 'wrap',
      }}
    >
      <input
        type="datetime-local"
        value={startDt}
        step="60"
        onChange={(e) => handleStartChange(e.target.value)}
        style={inputStyle}
      />
      <span style={{ fontSize: '12px' }}>~</span>
      <input
        type="datetime-local"
        value={endDt}
        step="60"
        onChange={(e) => handleEndChange(e.target.value)}
        style={inputStyle}
      />
      {formatted && (
        <span
          style={{
            fontSize: '12px',
            color: '#374151',
            marginLeft: 4,
            whiteSpace: 'nowrap',
          }}
        >
          {formatted}
        </span>
      )}
    </div>
  );
};

const Page1 = ({ data, editable, onUpdate, onToggleRecovery }) => {
  const p = data.programInfo;
  const total = (data.recipients || []).length;
  const attendedCount = (data.recipients || []).filter(
    (r) => r.attended,
  ).length;
  const computedRate =
    total > 0
      ? `${attendedCount}/${total}(${Math.round((attendedCount / total) * 100)}%)`
      : '';
  const cell = (key, multiline = false, placeholder = '', maxLength) =>
    editable ? (
      <Field
        value={p[key] ?? ''}
        onChange={(v) => onUpdate(key, v)}
        multiline={multiline}
        placeholder={placeholder}
        maxLength={maxLength}
      />
    ) : (
      p[key]
    );

  return (
    <div className="rp-a4">
      <p className="rp-text-10 rp-left">{data.header.outline}</p>
      <h1 className="rp-text-2xl rp-bold rp-center rp-border2 rp-py3 rp-my2 rp-rounded">
        {data.header.title}
      </h1>
      {data.header.category && (
        <div className="rp-text-xl rp-center rp-mb1">
          {data.header.category}
        </div>
      )}
      <div className="rp-text-lg rp-bold rp-right rp-mb2">
        {data.header.centerName}
      </div>
      <table className="rp-table rp-border2 rp-text-xs rp-mb4">
        <tbody>
          <tr className="rp-h10">
            <td
              className="rp-border rp-bg-gray rp-p2 rp-bold rp-center"
              style={{ width: '16%' }}
            >
              프로그램 활동명
            </td>
            <td className="rp-border">
              {cell('name', false, '프로그램 활동명을 입력하세요', 50)}
            </td>
            <td
              className="rp-border rp-bg-gray rp-p2 rp-bold rp-center"
              style={{ width: '18%' }}
            >
              프로그램 그룹
            </td>
            <td className="rp-border">
              {cell('group', false, '프로그램 그룹을 입력하세요', 30)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p1 rp-bold rp-center">
              프로그램 유형 구분
            </td>
            <td colSpan={3} className="rp-border">
              {cell('type', false, '프로그램 유형 구분을 입력하세요', 50)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              운영일시
            </td>
            <td colSpan={3} className="rp-border">
              {editable ? (
                <DateTimeField onChange={(v) => onUpdate('date', v)} />
              ) : (
                p.date
              )}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              작성자
            </td>
            <td className="rp-border">
              {cell('author', false, '작성자명을 입력하세요', 15)}
            </td>
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              시설장
            </td>
            <td className="rp-border">
              {cell('director', false, '시설장명을 입력하세요', 15)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              장소
            </td>
            <td className="rp-border">
              {cell('location', false, '장소를 입력하세요', 30)}
            </td>
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              참여자/현원(참여율)
            </td>
            <td className="rp-border">
              {editable ? (
                <input className="rp-input" value={computedRate} disabled />
              ) : (
                computedRate
              )}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              진행자명
            </td>
            <td colSpan={3} className="rp-border">
              {cell('instructors', false, '진행자명을 입력하세요', 100)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              준비물
            </td>
            <td colSpan={3} className="rp-border">
              {cell('materials', false, '준비물을 입력하세요', 100)}
            </td>
          </tr>
          <tr className="rp-h16">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              목표
            </td>
            <td colSpan={3} className="rp-border">
              {cell('goal', true, '목표를 입력하세요', 300)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              프로그램 내용
              <br />
              (진행과정)
            </td>
            <td colSpan={3} className="rp-border">
              {cell('content', true, '프로그램 내용을 입력하세요', 500)}
            </td>
          </tr>
          <tr className="rp-h10">
            <td className="rp-border rp-bg-gray rp-p2 rp-bold rp-center">
              전반적 평가
            </td>
            <td colSpan={3} className="rp-border">
              {cell('overallEvaluation', true, '전반적 평가를 입력하세요', 300)}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="rp-text-xl rp-bold rp-center rp-mb2">기능회복훈련</p>
      <table className="rp-table rp-border2 rp-text-10">
        <tbody>
          <tr className="rp-h10">
            <td
              colSpan={7}
              className="rp-border rp-bg-gray rp-p2 rp-bold rp-center"
            >
              급여제공 기록지 &gt; 기능회복훈련 &gt; 신체·인지기능 향상
              프로그램에 표시
            </td>
            <td colSpan={1} className="rp-border rp-p2 rp-bold rp-center">
              V
            </td>
          </tr>
          <tr>
            {data.recoveryTraining.map((textArray, idx) => (
              <td
                key={idx}
                className="rp-bg-gray rp-p1 rp-bold rp-center rp-border"
                style={{ width: '12.5%' }}
              >
                <div className="rp-flex rp-flex-col rp-leading">
                  {textArray.map((line, lineIdx) => (
                    <span key={lineIdx}>{line}</span>
                  ))}
                </div>
              </td>
            ))}
          </tr>
          <tr className="rp-h8">
            {Array.from({ length: 8 }).map((_, idx) => {
              const checked = data.recoveryChecks?.[idx] ?? false;
              return (
                <td
                  key={idx}
                  className={`rp-bg-white rp-border rp-center rp-bold${editable ? ' rp-check-cell' : ''}`}
                  onClick={editable ? () => onToggleRecovery(idx) : undefined}
                >
                  {checked ? 'V' : ''}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Page2 = ({ data, editable, onUpdateRecipient, onToggleAllAttended }) => {
  const allAttended =
    (data.recipients || []).length > 0 &&
    (data.recipients || []).every((r) => r.attended);
  return (
    <div className="rp-a4">
      <p className="rp-text-xl rp-bold rp-center rp-mb2">수급자 리스트</p>
      <table className="rp-table rp-border2 rp-text-9 rp-center">
        <thead className="rp-bg-gray rp-bold">
          <tr className="rp-border-b">
            <th
              rowSpan={2}
              className="rp-border-r rp-p1"
              style={{ width: '5%' }}
            >
              연번
            </th>
            <th
              rowSpan={2}
              className="rp-border-r rp-p1"
              style={{ width: '8%' }}
            >
              수급자명
            </th>
            <th
              rowSpan={2}
              className="rp-border-r rp-p1"
              style={{ width: '9%' }}
            >
              참여
              {editable && (
                <button
                  type="button"
                  onClick={onToggleAllAttended}
                  style={{
                    display: 'block',
                    margin: '3px auto 0',
                    padding: '1px 4px',
                    fontSize: 9,
                    lineHeight: 1.3,
                    fontWeight: 600,
                    background: allAttended ? '#ef4444' : '#2563eb',
                    color: 'white',
                    border: 'none',
                    borderRadius: 3,
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    letterSpacing: '-0.02em',
                  }}
                >
                  {allAttended ? '전체해제' : '전체선택'}
                </button>
              )}
            </th>
            <th
              colSpan={3}
              className="rp-border-r rp-p1"
              style={{ width: '15%' }}
            >
              참여도
            </th>
            <th
              colSpan={3}
              className="rp-border-r rp-p1"
              style={{ width: '15%' }}
            >
              만족도
            </th>
            <th
              colSpan={3}
              className="rp-border-r rp-p1"
              style={{ width: '15%' }}
            >
              수행도
            </th>
            <th rowSpan={2} className="rp-p1" style={{ width: '33%' }}>
              반응 및 특이사항(미참여 사유)
            </th>
          </tr>
          <tr className="rp-border-b2">
            {Array.from({ length: 9 }).map((_, i) => (
              <th key={i} className="rp-border-r rp-p1">
                {SCORE_LABELS[i % 3]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.recipients.map((r, i) => {
            const attended = r.attended ?? false;
            return (
              <tr key={i} className="rp-border-b">
                <td className="rp-border-r">{i + 1}</td>
                <td className="rp-border-r rp-bold">{r.name}</td>
                <td
                  className={`rp-border-r${editable ? ' rp-check-cell' : ''}`}
                  onClick={
                    editable
                      ? () => onUpdateRecipient(i, 'attended')
                      : undefined
                  }
                >
                  {attended ? 'V' : ''}
                </td>
                {Array.from({ length: 9 }).map((_, j) => {
                  const scoreKey = SCORE_KEYS[Math.floor(j / 3)];
                  const label = SCORE_LABELS[j % 3];
                  const isSelected = r.scores?.[scoreKey] === label;
                  const isDisabled = !attended;
                  let cellClass = 'rp-border-r';
                  if (editable) {
                    if (isDisabled) cellClass += ' rp-cell-disabled';
                    else cellClass += ' rp-radio-cell';
                  }
                  return (
                    <td
                      key={j}
                      className={cellClass}
                      onClick={
                        editable && !isDisabled
                          ? () => onUpdateRecipient(i, scoreKey, label)
                          : undefined
                      }
                    >
                      {isSelected ? 'V' : ''}
                    </td>
                  );
                })}
                <td className="rp-left">
                  {editable ? (
                    <textarea
                      className="rp-note-input"
                      value={r.note ?? ''}
                      onChange={(e) =>
                        onUpdateRecipient(i, 'note', e.target.value)
                      }
                      placeholder="반응 및 특이사항(미참여 사유)을 입력하세요"
                      maxLength={200}
                      rows={2}
                    />
                  ) : (
                    r.note
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const PiCareReportPreview = ({ isOpen, onClose, data }) => {
  const [formData, setFormData] = useState(() => ({
    ...data,
    recipients: normalizeRecipients(data.recipients),
  }));

  useEffect(() => {
    setFormData({ ...data, recipients: normalizeRecipients(data.recipients) });
  }, [data]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  if (!isOpen) return null;

  const updateProgramInfo = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      programInfo: { ...prev.programInfo, [key]: value },
    }));
  };

  const updateRecipient = (idx, field, value) => {
    setFormData((prev) => {
      const recipients = prev.recipients.map((r, i) => {
        if (i !== idx) return r;
        if (field === 'attended') {
          const nowAttended = !r.attended;
          if (!nowAttended) {
            return {
              ...r,
              attended: false,
              scores: {
                participation: null,
                satisfaction: null,
                performance: null,
              },
              note: '',
            };
          }
          return { ...r, attended: true };
        }
        if (SCORE_KEYS.includes(field)) {
          return {
            ...r,
            scores: {
              ...r.scores,
              [field]: r.scores[field] === value ? null : value,
            },
          };
        }
        return { ...r, [field]: value };
      });
      return { ...prev, recipients };
    });
  };

  const toggleAllAttended = () => {
    setFormData((prev) => {
      const allAttended = prev.recipients.every((r) => r.attended);
      const recipients = prev.recipients.map((r) => {
        if (allAttended) {
          return {
            ...r,
            attended: false,
            scores: {
              participation: null,
              satisfaction: null,
              performance: null,
            },
            note: '',
          };
        }
        return { ...r, attended: true };
      });
      return { ...prev, recipients };
    });
  };

  const toggleRecoveryCheck = (idx) => {
    setFormData((prev) => {
      const checks = [...(prev.recoveryChecks ?? Array(8).fill(false))];
      checks[idx] = !checks[idx];
      return { ...prev, recoveryChecks: checks };
    });
  };

  const handleDownload = () => generateDocx(formData);

  const handlePrint = () => {
    const printArea = document.getElementById('picare-rp-print-area');
    if (!printArea) return;

    const existing = document.getElementById('picare-rp-iframe');
    if (existing) existing.remove();

    const iframe = document.createElement('iframe');
    iframe.id = 'picare-rp-iframe';
    iframe.style.cssText =
      'position:fixed;top:0;left:0;width:0;height:0;border:none;visibility:hidden;';
    document.body.appendChild(iframe);

    const doc = iframe.contentDocument;
    doc.open();
    doc.write(
      `<!DOCTYPE html><html><head><meta charset="utf-8"/><style>${PRINT_STYLES}</style></head><body>${printArea.innerHTML}</body></html>`,
    );
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => iframe.remove(), 1000);
    };
  };

  const pageLabel = (n, total) => (
    <div
      style={{
        fontSize: 10,
        letterSpacing: '0.18em',
        color: '#9a9a9a',
        fontWeight: 600,
        userSelect: 'none',
        marginBottom: 10,
        textTransform: 'uppercase',
      }}
    >
      {`Page ${n} / ${total}`}
    </div>
  );

  return (
    <>
      <style>{REPORT_CSS}</style>
      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'rgba(0,0,0,0.6)',
          backdropFilter: 'blur(4px)',
          padding: 16,
        }}
      >
        <div
          style={{
            background: 'white',
            borderRadius: 12,
            width: '100%',
            maxWidth: 960,
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0 25px 50px rgba(0,0,0,0.4)',
            overflow: 'hidden',
          }}
        >
          {/* 툴바 */}
          <div
            style={{
              padding: '12px 24px',
              borderBottom: '1px solid #e2e8f0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              background: '#f8fafc',
              flexShrink: 0,
            }}
          >
            <span
              style={{ fontWeight: 'bold', color: '#374151', fontSize: 14 }}
            >
              프로그램 운영기록지 작성
            </span>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <Button
                onClick={handleDownload}
                variant="contained"
                size="small"
                startIcon={<FileDownloadIcon fontSize="small" />}
                sx={{
                  background: '#1d4ed8',
                  '&:hover': { background: '#1e40af' },
                  color: 'white',
                  fontSize: 12,
                  textTransform: 'none',
                }}
              >
                DOCX 저장
              </Button>
              <Button
                onClick={handlePrint}
                variant="contained"
                size="small"
                startIcon={<PrintIcon fontSize="small" />}
                sx={{
                  background: '#374151',
                  '&:hover': { background: '#1f2937' },
                  color: 'white',
                  fontSize: 12,
                  textTransform: 'none',
                }}
              >
                인쇄하기
              </Button>
              <IconButton onClick={onClose} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </div>
          </div>

          {/* 스크롤 영역 */}
          <div
            style={{
              flex: 1,
              overflowY: 'auto',
              background: '#525659',
              padding: '36px 24px 52px',
            }}
          >
            {/* 인쇄용 숨김 영역 (plain text) */}
            <div id="picare-rp-print-area" style={{ display: 'none' }}>
              <Page1
                data={formData}
                editable={false}
                onUpdate={updateProgramInfo}
                onToggleRecovery={toggleRecoveryCheck}
              />
              <Page2
                data={formData}
                editable={false}
                onUpdateRecipient={updateRecipient}
              />
            </div>

            {/* 화면 미리보기 (editable) */}
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  marginBottom: 12,
                }}
              >
                {pageLabel(1, 2)}
                <div style={{ boxShadow: PAGE_SHADOW }}>
                  <Page1
                    data={formData}
                    editable
                    onUpdate={updateProgramInfo}
                    onToggleRecovery={toggleRecoveryCheck}
                  />
                </div>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 14,
                  width: '210mm',
                  margin: '24px 0',
                  userSelect: 'none',
                }}
              >
                <div
                  style={{
                    flex: 1,
                    height: 1,
                    background: 'rgba(255,255,255,0.15)',
                  }}
                />
                <span
                  style={{
                    fontSize: 9,
                    color: '#888',
                    letterSpacing: '0.22em',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                  }}
                >
                  Next Page
                </span>
                <div
                  style={{
                    flex: 1,
                    height: 1,
                    background: 'rgba(255,255,255,0.15)',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                {pageLabel(2, 2)}
                <div style={{ boxShadow: PAGE_SHADOW }}>
                  <Page2
                    data={formData}
                    editable
                    onUpdateRecipient={updateRecipient}
                    onToggleAllAttended={toggleAllAttended}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PiCareReportPreview;
